import React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import List from "./utilities/List";
import SecretaryWaitingList from "./utilities/SecretaryWaitingList";
import moment from "moment-timezone";
class WaitingList extends React.Component {
  state = {};

  render() {
    if (this.props.getColors.loading) {
      return <p>laoding colors</p>;
    }
    if (this.props.role === "SECRETARY") {
      return (
        <SecretaryWaitingList
          slots={this.props.slots}
          colors={this.props.getColors.allColors}
        />
      );
    } else {
      return (
        <List
          doctorId={this.props.doctorId}
          slots={this.props.slots.filter(
            s =>
              s.doctor.id === this.props.doctorId &&
              moment(s.startTime).isSame(moment(), "day")
          )}
          colors={this.props.getColors.allColors}
        />
      );
    }
  }
}

const GET_COLORS_QUERY = gql`
  query {
    allColors {
      id
      color
    }
  }
`;

export default compose(
  graphql(GET_COLORS_QUERY, {
    name: "getColors"
  })
)(WaitingList);



// WEBPACK FOOTER //
// ./src/components/WaitingList.js